import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BlogHero from "../components/BlogHero";
import "./BlogPost.css";


const BlogPost = ({ isDarkMode }) => {
  const { slug } = useParams();

  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    fetch(`https://astrasighttech.com/api/blog.php?slug=${encodeURIComponent(slug)}`)
      .then(async (res) => {
        const data = await res.json();

        if (!res.ok) {
          throw new Error(data.error || "Failed to load blog post");
        }

        return data;
      })
      .then((data) => {
        setBlog(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [slug]);

  if (loading) {
    return <p className="blog-loading">Loading blog post...</p>;
  }

  if (error) {
    return <p className="blog-error">{error}</p>;
  }

  if (!blog) {
    return <p className="blog-error">Blog post not found.</p>;
  }

  return (
   <>
  <BlogHero isDarkMode={isDarkMode} />

  <article className={`blog-post ${isDarkMode ? "dark" : ""}`}>
    <div className="blog-meta">
      <span>By {blog.author}</span>
      <span>{new Date(blog.created_at).toLocaleDateString()}</span>
    </div>

    <div
      className="blog-content"
      dangerouslySetInnerHTML={{ __html: blog.content }}
    />
  </article>
</>

  );
};

export default BlogPost;
